import React, { useState } from 'react';
import {
    ConfirmButton,
    ErrorInfo,
    InputWrapper,
    LoginInfo,
    LoginInfoBold,
    StyledForm,
    StyledFormRow,
    StyledInput,
    StyledLabel,
} from './LoginForm.styles';
import Logo from '../../../components/logos/Logo/Logo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { connect } from 'react-redux';
import { loginUser } from '../../../helpers/fetchData';
import { loginAccount } from '../../../actions/loginActions';
import { useHistory } from 'react-router';

const LoginForm = ({ loggedIn, loginAccount }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [inputType, setInputType] = useState('password');
    const [error, setError] = useState(false);
    const history = useHistory();

    const changeInputType = () => {
        if (inputType === 'password') {
            setInputType('text');
        } else {
            setInputType('password');
        }
    };

    const clear = () => {
        setUsername('');
        setPassword('');
    };

    const login = () => {
        loginUser(username, password)
            .then((res) => {
                if (res.status === 200) {
                    clear();
                    loginAccount();
                    redirectToAdminPanel();
                } else {
                    setError(true);
                }
            })
            .catch((e) => setError(true));
    };

    const redirectToAdminPanel = () => {
        history.push('/admin-access/panel');
    };

    return (
        <>
            <StyledForm>
                <Logo
                    style={{
                        position: 'absolute',
                        right: -60,
                        top: -10,
                        transform: 'rotate(5deg)',
                        opacity: 0.05,
                        width: 350,
                        height: 350,
                    }}
                />
                <StyledFormRow>
                    <StyledLabel htmlFor={'username'}>
                        {'Nazwa użytkownika'}
                    </StyledLabel>
                    <StyledInput
                        id={'username'}
                        style={{ marginTop: 10 }}
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                </StyledFormRow>
                <StyledFormRow style={{ marginTop: 0 }}>
                    <StyledLabel htmlFor={'password'}>{'Hasło'}</StyledLabel>
                    <InputWrapper>
                        <StyledInput
                            id={'password'}
                            type={inputType}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        <FontAwesomeIcon
                            onClick={changeInputType}
                            icon={inputType === 'password' ? faEye : faEyeSlash}
                            color={'black'}
                            style={{
                                cursor: 'pointer',
                                width: 15,
                                height: 15,
                                position: 'absolute',
                                right: 0,
                                top: 6,
                            }}
                        />
                    </InputWrapper>
                </StyledFormRow>
                <ConfirmButton type={'button'} onClick={() => login()}>
                    {'ZALOGUJ'}
                </ConfirmButton>
            </StyledForm>
            <LoginInfo>
                <LoginInfoBold>{'Uwaga: '}</LoginInfoBold>
                {
                    'Dostęp przeznaczony tylko dla uprawnionych użytkowników systemu.'
                }
            </LoginInfo>
            {error && (
                <ErrorInfo>
                    {'Wystąpił błąd podczas logowania do systemu.'}
                </ErrorInfo>
            )}
        </>
    );
};

const mapStateToProps = ({ loginReducer }) => loginReducer;
const mapDispatchToProps = { loginAccount };

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);
